import {
  DEFAULT_OAUTH_SCOPES,
  OauthClientIds,
  OauthProviderCloudFunctions,
  OauthProviderEndpoints,
} from '@learnics/models/src/utils/oauthConfig.mjs'

/**
 * This function will redirect whatever page it is called from to the provider oauth2
 * login page. It will then redirect the user back to the page it was called from
 * with the access token in the URL.
 *
 * @param {string} providerId - The ID of the OAuth provider to use for login, e.g., 'google.com' or 'microsoft.com'.
 * @param {string[]} scopes - The scopes to request - either a string or an array of strings.
 * @param {any} state - The state to pass through the login process, allowing you to return the user to where they
 *                      were before they logged in.
 * @param {boolean} include_granted_scopes - Whether to include granted scopes - This should probably always be true, but perhaps not.
 * @param {string} access_type - The access type to request - this should probably always be "offline", but perhaps not.
 * @param {string} prompt - The prompt to request
 * @param {string} login_hint - The login hint to request from Google - this is the email address of the user to log in, or the Google ID of the user to log in.
 */
export function redirectToOauthLogin(
  providerId,
  scopes,
  state = { action: 'login-test' },
  include_granted_scopes = true,
  access_type = 'offline',
  prompt = 'consent',
  login_hint = null,
) {
  scopes ||= []
  scopes = [
    ...scopes.map((scope) => (Array.isArray(scope) ? scope[0] : scope)),
    ...DEFAULT_OAUTH_SCOPES[providerId],
  ]
  state.local = window.origin.includes('localhost')
  // Google's OAuth 2.0 endpoint for requesting an access token
  const oauth2Endpoint = OauthProviderEndpoints[providerId]

  // Create element to open OAuth 2.0 endpoint in new window.
  const form = document.createElement('form')
  form.setAttribute('method', 'GET') // Send as a GET request.
  form.setAttribute('action', oauth2Endpoint)

  // Parameters to pass to OAuth 2.0 endpoint.
  const params = {
    client_id: OauthClientIds[providerId],
    redirect_uri:
      process.env.VUE_APP_BASE_URL +
      `/cloud/${OauthProviderCloudFunctions[providerId]}`,
    response_type: 'code',
    scope: scopes.join(' '),
    state: JSON.stringify({
      ...state,
      scopes,
      include_granted_scopes,
      access_type,
      prompt,
      login_hint,
      providerId,
    }),
    access_type,
    include_granted_scopes: !!include_granted_scopes + '',
    prompt,
  }
  if (login_hint) {
    params.login_hint = login_hint
  }

  params.scope = params.scope.trim()

  for (const p in params) {
    const input = document.createElement('input')
    input.setAttribute('type', 'hidden')
    input.setAttribute('name', p)
    input.setAttribute('value', params[p])
    form.appendChild(input)
  }

  // Add form to page and submit it to open the OAuth 2.0 endpoint.
  document.body.appendChild(form)

  // Submit the form to redirect to OAuth 2.0 endpoint.
  form.submit()
}
